export default {"src":"/_next/static/media/Payment_declined.2146ef79.gif","height":1080,"width":1920,"blurWidth":0,"blurHeight":0};